export default __webpack_public_path__ + "static/media/folder_no_file.70b7c3b9.svg";